module.exports = __webpack_public_path__ + "img/18.a9c53882.jpg";